<template>
  <div class="box">
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack2.png" alt />
    </div>
    <div class="text">恭喜您</div>
    <div class="title">获得好友赠送的优惠券</div>
    <div class="couponInfo">{{ CouponInfo.coupontype_name }}</div>
    <div class="shop">{{ CouponInfo.shop.name }}</div>
    <div class="time">有效期至：{{ CouponInfo.end_time }}</div>
    <div class="btn" v-on:click="share_coupon">{{ showBtnText }}</div>
    <div class="bottomText">
      请进入珍券微信公众号，点击<span style="color: #fde0aa">“我的券”</span>查看
    </div>
  </div>
</template>

<script>
export default {
  name: "giveTo",
  data() {
    return {
      CShttp: this.$store.state.CShttp,
      useId: this.$store.state.useId,
      CouponInfo: "",
      IconImg: "",
      codes: "",
      imageUrl: "",
      codesEWM: "",
      showBtn: false,
      uid: "",
      showBtnText: "立即领取",
    };
  },
  components: {},
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo,
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;

    this.showBtn = true;
    this.codesEWM = this.$route.query.pcodes;
    this.uid = this.$route.query.id; //分享人 id
    this.getCoupon();
    console.log(this.uid, this.useId);

    //  this.useCoupon()
    this.GetWx();
  },
  methods: {
    share_coupon() {
      this.$http
        .get("/api/Coupon/share_coupon", {
          params: {
            code: this.codesEWM,
            uid: this.$store.state.useId,
            share_uid: this.uid,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            this.showBtn = false;
            this.$store.commit("showLoading", false); //关闭加载图标
            this.$store.commit("showMsg", {
              show: true,
              type: true,
              msg: "",
            }); //显示领取成功
            this.showBtnText = "已领取";
          } else {
            this.$store.commit("showLoading", false); //关闭加载图标
            this.$store.commit("showMsg", {
              show: true,
              type: false,
              msg: res.data.data.action,
            }); //显示领取失败
          }
        });
    },
    getCoupon() {
      var that = this;
      this.$http
        .get("api/coupon/code_getcoupon?codes=" + this.codesEWM, {})
        .then((res) => {
          console.log("soces", res.data.data.action);
          this.imageUrl=this.$store.state.CShttp + res.data.data.action.shop.shop_icon_image,
          that.CouponInfo = res.data.data.action;
          that.CouponInfo.category = res.data.data.action.coupontype_name;
        });
    },
    GetWx() {
      var that = this;
      console.log(that.imageUrl)
      var IsPhone = /iphone/.test(navigator.userAgent.toLowerCase()); //判断是不是苹果
      console.log('href',location.href);
      this.$http
        .get("/api/shop/get_SignPackage", {
          params: {
            url: encodeURIComponent(location.href),
          },
        })
        .then((res) => {
          console.log(res.data.msg);
          that.$store.commit("wxJSSDK", res.data.msg);
          wx.config({
            debug: false, // true:调试时候弹窗
            appId: res.data.msg.appId, // 微信appid
            timestamp: res.data.msg.timestamp, // 时间戳
            nonceStr: res.data.msg.nonceStr, // 随机字符串
            signature: res.data.msg.signature, // 签名
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "onMenuShareAppMessage", //获取地理位置
            ],
          });
        });
      wx.ready(function () {
        wx.onMenuShareAppMessage({
          title: "分享商家", // 分享标题
          desc: "核销优惠券", // 分享描述
          link:
            window.location.origin +
            "/redirect.html?shareRedirect=" +
            encodeURIComponent(
              "https://zqconsumer.zeego2.cc#/?type=giveTo&pcodes=" +
                that.codesEWM +
                "&id=" +
                that.uid
            ), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imageUrl, // 分享图标
          success: function () {
            console.log(that.imageUrl)
            that.shareIMG();
            console.log("分享成功");
            console.log(
              "uid",
              that.showBtn ? that.uid : that.$store.state.useId
            );
            that.$http
              .get("api/coupon/share_save_coupon", {
                params: {
                  code: that.codesEWM,
                  uid: that.showBtn ? that.uid : that.$store.state.useId,
                },
              })
              .then((res) => {
                console.log("分享请求", res);
              });
            // 设置成功
          },
        });
      });
      wx.error(function () {
        console.log("失败");
      });
    },
    shareIMG() {
      this.$store.commit("showMsg", {
        show: true,
        type: true,
        msg: "分享成功",
      }); //显示领取成功
    },
    // 查看规则
    watchRule(rule) {
      alert("券规则：" + rule);
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100vh;
  background: url(../assets/GiveTo.jpg) no-repeat;
  background-size: 100% 100%;
  color: white;
  text-align: center;
}
.back {
  position: absolute;
  top: 0.5rem;
  left: 0.2rem;
  width: 0.7rem;
  height: 0.7rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.text {
  padding-top: 5vh;
  font-size: 7vh;
  font-weight: 700;
  line-height: 10vh;
}
.title {
  font-size: 2vh;
  line-height: 5vh;
}
.couponInfo {
  font-size: 4vh;
  line-height: 5vh;
  margin-top: 30vh;
  margin-bottom: 0.2vh;
}
.shop,
.time {
  font-size: 2vh;
  line-height: 3vh;
}
.btn {
  font-size: 3vh;
  line-height: 6vh;
  margin-top: 12vh;
}
.bottomText {
  line-height: 4vh;
  font-size: 0.24rem;
  margin-top: 6vh;
}
</style>
